import React from 'react';
import { Skeleton } from "../ui/skeleton";
import { ActionMenu } from "../shared/ActionMenu";
import { CommentDetailPopover } from "../shared/CommentDetailPopover";

const CommentTable = ({
    items,
    loading = false,
    onEdit,
    onDeleteRequest
}) => {
    return (
        <div className="relative w-full overflow-auto rounded-md border">
            <table className="w-full caption-bottom text-sm">
                <thead className="[&_tr]:border-b bg-muted/50">
                    <tr>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground w-auto">
                            Commentaire
                        </th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground w-24">
                            Direction
                        </th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground w-32">
                            Date
                        </th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground w-24">
                            Time frame
                        </th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground w-20">
                            %
                        </th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground w-32">
                            Prédicteur
                        </th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground w-24">
                            Stock
                        </th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground w-28">
                            Reading Ease
                        </th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground w-24">
                            Grade Level
                        </th>
                        <th className="h-12 px-4 text-right align-middle font-medium text-muted-foreground w-32">
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody className="[&_tr:last-child]:border-0">
                    {loading ? (
                        Array.from({ length: 5 }).map((_, i) => (
                            <tr key={`skeleton-${i}`} className="border-b">
                                <td className="p-4 align-middle"><Skeleton className="h-4 w-full" /></td>
                                <td className="p-4 align-middle"><Skeleton className="h-4 w-12" /></td>
                                <td className="p-4 align-middle"><Skeleton className="h-4 w-20" /></td>
                                <td className="p-4 align-middle"><Skeleton className="h-4 w-16" /></td>
                                <td className="p-4 align-middle"><Skeleton className="h-4 w-12" /></td>
                                <td className="p-4 align-middle"><Skeleton className="h-4 w-20" /></td>
                                <td className="p-4 align-middle"><Skeleton className="h-4 w-16" /></td>
                                <td className="p-4 align-middle"><Skeleton className="h-4 w-16" /></td>
                                <td className="p-4 align-middle"><Skeleton className="h-4 w-14" /></td>
                                <td className="p-4 align-middle"><Skeleton className="h-4 w-24" /></td>
                            </tr>
                        ))
                    ) : items.length === 0 ? (
                        <tr>
                            <td colSpan="10" className="p-4 align-middle text-center text-muted-foreground">
                                Aucun commentaire
                            </td>
                        </tr>
                    ) : (
                        items.map((item) => (
                            <tr key={item.comment_id} id={`comment-${item.comment_id}`} className="border-b transition-colors hover:bg-muted/50">
                                <td className="p-4 align-middle">
                                    <span className="max-w-xs truncate block">{item.comment_text}</span>
                                </td>
                                <td className="p-4 align-middle">{item.direction}</td>
                                <td className="p-4 align-middle">
                                    <CommentDetailPopover comment={item}>
                                        <a
                                            href={`#comment-${item.comment_id}`}
                                            className="underline text-primary hover:text-primary/80"
                                        >
                                            {item.created_at ? new Date(item.created_at).toLocaleDateString('fr-FR') : '—'}
                                        </a>
                                    </CommentDetailPopover>
                                </td>
                                <td className="p-4 align-middle">
                                    {typeof item.time_frame === 'string' ? item.time_frame : JSON.stringify(item.time_frame)}
                                </td>
                                <td className="p-4 align-middle">
                                    {item.percentage_change != null ? `${item.percentage_change}%` : '—'}
                                </td>
                                <td className="p-4 align-middle">
                                    {item.predictorname || 'Nom inconnu'}
                                </td>
                                <td className="p-4 align-middle font-semibold">{item.fk_stock_symbol}</td>
                                <td className="p-4 align-middle">
                                    {item.reading_ease != null ? (
                                        <span className={
                                            item.reading_ease > 60 ? 'text-green-600 font-bold' :
                                            item.reading_ease >= 30 ? 'text-orange-500 font-bold' :
                                            'text-red-600 font-bold'
                                        }>
                                            {item.reading_ease.toFixed(1)}
                                        </span>
                                    ) : (
                                        <span className="text-muted-foreground">—</span>
                                    )}
                                </td>
                                <td className="p-4 align-middle">
                                    {item.grade_level != null ? item.grade_level.toFixed(1) : <span className="text-muted-foreground">—</span>}
                                </td>
                                <td className="p-4 align-middle text-right" style={{ minWidth: 120 }}>
                                    <ActionMenu
                                        onEdit={() => onEdit(item)}
                                        onDelete={() => onDeleteRequest(item.comment_id)}
                                    />
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default CommentTable;